import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Leaf, ShieldCheck, Truck } from "lucide-react";

const CTA = () => {
  const navigate = useNavigate();
  return (
    <section id="csr" className="relative bg-stone-50/40 py-20 lg:py-24">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative aspect-[4/3] overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1616252576862-bd9abd7467f9?w=1400&q=80"
              alt="Our nut sourcing commitment"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <div>
            <div className="text-xs tracking-[0.3em] text-stone-500 uppercase">Our commitment</div>
            <h2 className="font-display text-4xl md:text-5xl text-stone-900 mt-3">
              Responsibly sourced, slowly crafted
            </h2>
            <div className="nut-divider-left" />
            <p className="mt-6 text-stone-600 leading-relaxed">
              NutExpert builds long‑term partnerships with farmers across five continents. Every
              lot is traceable, every roast is overseen by our master nut roasters — because what&apos;s
              good for you should also be good for the planet.
            </p>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#c8232c]/10 text-[#c8232c] flex items-center justify-center">
                  <Leaf size={18} />
                </div>
                <div>
                  <div className="font-semibold text-stone-800 text-sm">Organic options</div>
                  <div className="text-xs text-stone-500">Certified by Ecocert</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#c8232c]/10 text-[#c8232c] flex items-center justify-center">
                  <ShieldCheck size={18} />
                </div>
                <div>
                  <div className="font-semibold text-stone-800 text-sm">Traceability</div>
                  <div className="text-xs text-stone-500">From farm to jar</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-[#c8232c]/10 text-[#c8232c] flex items-center justify-center">
                  <Truck size={18} />
                </div>
                <div>
                  <div className="font-semibold text-stone-800 text-sm">EU shipping</div>
                  <div className="text-xs text-stone-500">Free above €49</div>
                </div>
              </div>
            </div>

            <button onClick={() => navigate("/shop")} className="btn-primary mt-10 inline-flex items-center gap-2">
              Shop the collection <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
